import Navigation from "./Navigation";
import PlausibleEvents from "./PlausibleEvents";
import { ServiceSection } from "./Services";
import DragList from "./DragList";
import OtherToggle from "./OtherToggle";
import "./SwiperGalleries";

// navigation
const navContainer = <HTMLElement>document.querySelector(".nav");
const nav = new Navigation(navContainer);

// service section
const serviceSection = <HTMLElement>document.querySelector(".service-section");
if (serviceSection) {
    const services = new ServiceSection(serviceSection);
}

// draggable lists
const tagList = <HTMLElement>document.querySelector(".recipe-archive-section .filter .tag-list");
if (tagList) {
    const tagListScrollButtons = <NodeListOf<HTMLElement>>(
        document.querySelectorAll(".recipe-archive-section .filter .scroll-button")
    );
    const draggabeTagList = new DragList(tagList, tagListScrollButtons);
}

const contactForms = <NodeListOf<HTMLElement>>document.querySelectorAll(".contact-form");
contactForms.forEach((container) => {
    new OtherToggle(container);
});

const events = new PlausibleEvents();
